import { PigmentThemeProvider } from '@customink/pigment-react';
import { ProjectServiceApiProvider } from '@customink/project-service-react-components';
import { useEffect, useMemo } from 'react';
import ReactDOM from 'react-dom';

import { setFeatureFlagsFromUrl, signaler } from './utils/signaler';

import App from '@/components/App';
import ErrorBoundary from '@/components/ErrorBoundary';
import { RollbarProvider } from '@/components/RollbarProvider';
import { config } from '@/config/api.config';
import { useAuth } from '@/contexts/auth/AuthContext';
import { AuthProvider } from '@/contexts/auth/AuthProvider';
import { initializeInternalPreview } from '@/hooks/internalPreview';

const app = document.getElementById('root');

console.log('ENV Mode: ', import.meta.env.MODE);

// Initialize global atoms
initializeInternalPreview();

const EditorApp = () => {
  setFeatureFlagsFromUrl(signaler);
  const { user, tokens } = useAuth();
  const apiAuth = {
    tokens: {
      accessToken: tokens?.accessToken ?? '',
      idToken: tokens?.idToken ?? '',
    },
    user: {
      email: user?.email ?? '',
      id: user?.id ?? '',
    },
  };
  const isAuth0Enabled = false;
  const featureFlags = useMemo(
    () => ({
      isAuth0Enabled,
    }),
    [],
  );
  // prevent auto-zooming on field focus on iPhones
  useEffect(() => {
    if (navigator.userAgent.includes('iPhone')) {
      const viewport = document.querySelector('[name=viewport]');
      if (viewport) {
        viewport.setAttribute(
          'content',
          'width=device-width, initial-scale=1, maximum-scale=1',
        );
      }
    }
  }, []);

  return (
    <RollbarProvider>
      <ErrorBoundary>
        <ProjectServiceApiProvider
          auth={apiAuth}
          config={config}
          featureFlags={featureFlags}
          // TODO: is it okay that we're using the App as the api fallback?
          // Probably not anymore now that we call `useProject` in it -kp
          fallback={<App />}
        >
          <App />
        </ProjectServiceApiProvider>
      </ErrorBoundary>
    </RollbarProvider>
  );
};

ReactDOM.render(
  <PigmentThemeProvider>
    <AuthProvider>
      <EditorApp />
    </AuthProvider>
  </PigmentThemeProvider>,
  app,
);
